import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

const PrintableAcademicCalendar = ({ onBackToCalendar }) => {
  const calendarEvents = useSelector((state) => state.academicCalendar.calendarEvents);
  const [filterType, setFilterType] = useState('complete');
  const months = moment.months(); // ["January", "February", ...]
  const [selectedMonth, setSelectedMonth] = useState(moment().month()); // default: current month
  React.useEffect(() => {
    if (filterType === "month") {
      setSelectedMonth(moment().month()); // reset to current month every time
    }
  }, [filterType]);


  const getFilteredEvents = () => {
    if (filterType === 'complete') return calendarEvents;
    // Monthly filter
    if (filterType === 'month') {
      return calendarEvents.filter((item) => {
        const eventDate = moment(item.date, "DD-MM-YYYY");
        return eventDate.isValid() && eventDate.month() === Number(selectedMonth);
      });
    }

    if (filterType === 'session') {
      return calendarEvents.filter(
        item => item.type === 'sessionStart' || item.type === 'sessionEnd'
      );
    }

    return calendarEvents.filter(item => item.type === filterType);
  };

  const getFilterTitle = () => {
    switch (filterType) {
      case 'complete': return 'Complete Academic Calendar';
      case 'holiday': return 'Holidays';
      case 'celebration': return 'Celebrations';
      case 'awarenessDay': return 'Awareness Days';
      case 'competition': return 'Competitions';
      case 'exam': return 'Examinations';
      case 'ptm': return 'Parent Teacher Meetings';
      case 'session': return 'Session Start & End';
      case 'month': return `Events for ${months[selectedMonth]}`;
      default: return 'Calendar Items';
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById('printableContent');
    const printWindow = window.open('', '', 'height=800,width=1200');
    printWindow.document.write('<html><head><title>Academic Calendar Print</title>');
    printWindow.document.write('<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">');
    printWindow.document.write('<style>@media print { body { -webkit-print-color-adjust: exact; } table, th, td { border: 1px solid #dee2e6; border-collapse: collapse; } th, td { padding: 0.75rem; text-align: left; } .table-striped tbody tr:nth-of-type(odd) { background-color: rgba(0, 0, 0, 0.05); } }</style>');
    printWindow.document.write('</head><body style="margin: 20px;">');
    printWindow.document.write(printContent.innerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  const filteredEvents = getFilteredEvents();

  return (
    <div className="px-5 mx-5">
      {/* <h2 className="mb-4">Printable Academic Calendar View</h2> */}

      <div className="mb-3 d-flex align-items-center">
        <button className="btn btn-primary me-2" onClick={onBackToCalendar} >
          Back
        </button>
        <div className="d-flex align-items-center">
          <label htmlFor="filterOptions" className="form-label me-2 mb-0">Filter by:</label>
          <select
            id="filterOptions"
            className="form-select w-auto me-3"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="complete">Complete Calendar</option>
            <option value="holiday">Holidays</option>
            <option value="celebration">Celebrations</option>
            <option value="awarenessDay">Awareness Days</option>
            <option value="competition">Competitions</option>
            <option value="exam">Examinations</option>
            <option value="ptm">Parent Teacher Meetings</option>
            <option value="session">Session Start & End</option>
            <option value="month">Monthly</option>
          </select>
          {filterType === "month" && (
            <select
              className="form-select w-auto me-3"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              {months.map((m, i) => (
                <option key={i} value={i}>{m}</option>
              ))}
            </select>
          )}
        </div>
        <button className="btn btn-primary ms-auto" onClick={handlePrint}>Print</button>

      </div>

      <div id="printableContent" className="card shadow p-3">
        <h3 className="mb-3 text-center">{getFilterTitle()}</h3>
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>No of Days</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {
                [...filteredEvents]
                  .sort((a, b) => moment(a.date, "DD-MM-YYYY").valueOf() - moment(b.date, "DD-MM-YYYY").valueOf())
                  .map((item, index) => {
                    const start = moment(item.date, "DD-MM-YYYY");
                    const end = item.end_date ? moment(item.end_date, "DD-MM-YYYY") : start;

                    // Calculate number of days
                    let noOfDays = 0;
                    if (start.isValid() && end.isValid()) {
                      noOfDays = end.diff(start, 'days') + 1;
                    } else {
                      noOfDays = "N/A";
                    }

                    // Format details including time if available
                    let detailsContent = item.description || item.name;
                    if (item.start_time && item.end_time) {
                      detailsContent += ` (${item.start_time}-${item.end_time})`;
                    } else if (item.start_time) {
                      detailsContent += ` (${item.start_time})`;
                    }

                    return (
                      <tr key={`${item.id}-${item.type}-${index}`}>
                        <td>{index + 1}</td>
                        <td>{start.isValid() ? start.format("DD MMMM YYYY") : "Invalid Date"}</td>
                        <td>{end.isValid() ? end.format("DD MMMM YYYY") : "Invalid Date"}</td>
                        <td>{noOfDays}</td>
                        <td>{detailsContent}</td>
                      </tr>
                    );
                  })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PrintableAcademicCalendar;